export default (distance, options = {}) => {
  const defaultOptions = {
    style: 'unit', // One of https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#style or 'raw'
    unitSystem: 'metric', // 'metric' or 'imperial'
    locale: 'es',
    unit: 'meter', // One of https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#unit_2
    unitDisplay: 'long', // One of https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#unitdisplay
    maximumFractionDigits: 0
  }
  options = {...defaultOptions, ...options}
  // Fallback just in case unitSystem is overwritten without a value
  if (!options.unitSystem) {
    options.unitSystem = 'metric'
  }
  if (options.unitSystem === 'imperial') {
    distance = distance / 1610
    options.unit = 'mile'
    options.maximumFractionDigits = 2
  } else if (options.unitSystem === 'metric') {
    if (options.unit === 'kilometer') {
      distance = distance / 1000
      options.maximumFractionDigits = 2
    } else if (options.unit === 'meter') {
      options.maximumFractionDigits = 0
      if (distance >= 1000 && options.style !== 'raw') {
        options.unit = 'kilometer'
        distance = distance / 1000
        options.maximumFractionDigits = 2
      }
    }
  }
  if (options.style === 'raw') {
    return distance.toFixed(options.maximumFractionDigits)
  }
  return new Intl.NumberFormat(options.locale, { style: options.style, unit: options.unit, maximumFractionDigits: options.maximumFractionDigits, unitDisplay: options.unitDisplay }).format(
    distance
  )
}
